import { convertRowsToData } from '../utils/dataUtils'
import { extent as d3_extent } from 'd3-array'
export default function ProgressBarChartDataController(rows, config, hiddenItems) {
  let headers = rows[0]
  const propperHeaders = ['id', ...headers.slice(1)]
  let data = convertRowsToData([propperHeaders, ...rows.slice(1)], 1)
  if (hiddenItems) data = data.filter(d => hiddenItems.indexOf(d.id) < 0)

  let keyDict = {}
  keyDict[propperHeaders[1]] = 'value'
  keyDict[propperHeaders[2]] = 'total'

  data = data.map(d => ({
    id: d.id,
    ...d.value.reduce((accumulator, current) => {
      accumulator[keyDict[current.id]] = current.value
      return accumulator
    }, {}),
  }))

  data = data.map(d => {
    let percent = (100 * d.value) / d.total
    let getSafeValue = v => {
      return config.minBarHeight
        ? Math.sign(v || 1) * Math.max(config.minBarHeight, Math.abs(v))
        : +v
    }
    return { ...d, percent, safeValue: getSafeValue(percent) }
  })

  if (config.dataSorting !== 'none') {
    data.sort((a, b) => {
      let diff = a.percent - b.percent
      return config.dataSorting === 'asc' ? diff : -diff
    })
  }

  return data
}
